import { RichTextRenderer } from '@contember/react-client'
import { ChangeTextToIcon, type ChangeTextToIconElement } from './ChangeTextToIcon'
import { HighlightText, type HighlightTextElement } from './HighlightText'
import type { SubtitleTextElement } from './SubtitleText'
import { SubtitleText } from './SubtitleText'
import { type ColorUnderlineElement, ColorUnderlineText } from './ColorUnderline'

type CustomElements = ColorUnderlineElement | ChangeTextToIconElement | HighlightTextElement | SubtitleTextElement

export const RichTextRendererWithElements: typeof RichTextRenderer = (props) => {
	return (
		<RichTextRenderer
			{...props}
			renderElement={(...args) => {
				const [params] = args
				const element = params.element as (typeof params)['element'] | CustomElements
				switch (element.type) {
					case 'changeTextToIcon': {
						const elementChangeTextToIcon = element as ChangeTextToIconElement
						return <ChangeTextToIcon iconType={elementChangeTextToIcon.suchThat.iconType} />
					}
					case 'highlightText': {
						const elementHighlightText = element as HighlightTextElement
						return (
							<HighlightText
								highlightTextType={elementHighlightText.suchThat.highlightTextType}
								fillColor={elementHighlightText.suchThat.fillColor}
							>
								{params.children}
							</HighlightText>
						)
					}
					case 'subtitleText': {
						const elementSubtitleText = element as SubtitleTextElement
						return (
							<SubtitleText subtitleType={elementSubtitleText.suchThat.subtitleType}>{params.children}</SubtitleText>
						)
					}
					case 'colorUnderline': {
						const elementColorUnderlineText = element as unknown as ColorUnderlineElement
						return (
							<ColorUnderlineText colorUnderlineType={elementColorUnderlineText.suchThat.colorUnderlineType}>
								{params.children}
							</ColorUnderlineText>
						)
					}
				}
				const { renderElement } = props
				if (renderElement && typeof renderElement === 'function') {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					// biome-ignore lint/suspicious/noExplicitAny: <explanation>
					return (renderElement as any)(...args)
				}
				return params.fallback
			}}
		/>
	)
}
